// Auto-generated index file for English screen translations
// This file combines all screen namespace files into a single export

import activityFilters from './activityFilters.json';
import activity from './activity.json';
import authorizedAccounts from './authorizedAccounts.json';
import blacklistTab from './blacklistTab.json';
import claimInvite from './claimInvite.json';
import convertSVG from './convertSVG.json';
import devTools from './devTools.json';
import editFboName from './editFboName.json';
import enterTheDojo from './enterTheDojo.json';
import estimator from './estimator.json';
import faaMapping from './faaMapping.json';
import fboActivity from './fboActivity.json';
import fboAdmin from './fboAdmin.json';
import flaggedStacks from './flaggedStacks.json';
import forgotPassword from './forgotPassword.json';
import hangar from './hangar.json';
import hangarBuilderOptimizer from './hangarBuilderOptimizer.json';
import hangars from './hangars.json';
import labelingTool from './labelingTool.json';
import magicLinkLogin from './magicLinkLogin.json';
import maintenance from './maintenance.json';
import multiHangar from './multiHangar.json';
import noActiveFBO from './noActiveFBO.json';
import operationsInbox from './operationsInbox.json';
import ops from './ops.json';
import opsCenter from './opsCenter.json';
import pendingApprovalsTab from './pendingApprovalsTab.json';
import quarantine from './quarantine.json';
import ramp from './ramp.json';
import rampOptimization from './rampOptimization.json';
import ramps from './ramps.json';
import reports from './reports.json';
import resetPassword from './resetPassword.json';
import schedule from './schedule.json';
import settings from './settings.json';
import signup from './signup.json';
import stackMaster from './stackMaster.json';
import superAdmin from './superAdmin.json';
import tailRequestsTab from './tailRequestsTab.json';
import tenants from './tenants.json';
import verifyEmail from './verifyEmail.json';
import weeklyActivity from './weeklyActivity.json';

export default {
  activityFilters,
  activity,
  authorizedAccounts,
  blacklistTab,
  claimInvite,
  convertSVG,
  devTools,
  editFboName,
  enterTheDojo,
  estimator,
  faaMapping,
  fboActivity,
  fboAdmin,
  flaggedStacks,
  forgotPassword,
  hangar,
  hangarBuilderOptimizer,
  hangars,
  labelingTool,
  magicLinkLogin,
  maintenance,
  multiHangar,
  noActiveFBO,
  operationsInbox,
  ops,
  opsCenter,
  pendingApprovalsTab,
  quarantine,
  ramp,
  rampOptimization,
  ramps,
  reports,
  resetPassword,
  schedule,
  settings,
  signup,
  stackMaster,
  superAdmin,
  tailRequestsTab,
  tenants,
  verifyEmail,
  weeklyActivity,
};
